<div class="table-wrapper">
    <div>
        <aumico-button (click)="onCreateAccountingBasisPressed()">Add new Accounting Basis</aumico-button>
    </div>

    <aumico-settings-accounting-basis-list
        [data]="data"
        [languages]="languages"
        (editPressed)="editPressedEventHandler($event)"
    >
    </aumico-settings-accounting-basis-list>
</div>
